// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608030709/js/" + chunkId + "." + {"44":"9c127d66","225":"d133f9d3","481":"5420c37c","486":"e20d30f9","770":"20fb82f5"}[chunkId] + ".0.9943467210204715.chunk.js";
};